import { bindActionCreators } from 'redux';
import { setItems } from 'legacy-src/actions/classes';
import setUserSubjects from 'legacy-src/actions/userSubjects';
import { setAdminInfo } from 'legacy-src/actions/admin';
import { setSubject } from 'legacy-src/actions/subject';
import { setStudentsBySection } from 'legacy-src/actions/studentsBySection';

const useGetActions = ({ dispatch }) => {
  const actions = bindActionCreators(
    {
      setItemsAction: setItems,
      setUserSubjectsAction: setUserSubjects,
      setAdminInfoAction: setAdminInfo,
      setSubjectAction: setSubject,
      setStudentsBySectionAction: setStudentsBySection,
    },
    dispatch,
  );

  return actions;
};

export default useGetActions;
